export const LIST_ITEM_STYLE = {
    fontFamily: "Roboto",
    fontWeight: "400px",
    fontStyle: "Regular",
    fontSize: "11.67px",
    lineHeight: "14px",
    letterSpacing: "0%",
    verticalAlign: "middle",
};

export const MENU_LIST_STYLE = {
    height: "230px",
    gap: "4px",
    opacity: 1,
    display: "flex",
    flexDirection: "column",
}

export const PAPER_PROPS_STYLE = {
    width: "564px",
    gap: "4px",
    borderRadius: "3px",
    borderWidth: "1px",
    padding: "16px",
}

export const CSS_CHIP = {
    height: "18px",
    gap: "8px",
    opacity: 1,
    borderRadius: "3px",
    paddingTop: "2px",
    paddingRight: "8px",
    paddingBottom: "2px",
    paddingLeft: "8px",
    textEmphasis: "#203D48",
    fontFamily: "Roboto",
    fontWeight: "400px",
    fontStyle: "Regular",
    fontSize: "11.67px",
    lineHeight: "14px",
    letterSpacing: "0%",
    verticalAlign: "middle",
};